<template>
    <div>
        <div class="abandoned-baskets">
            <div class="row mb-standard mt-5 justify-content-center">
                <div class="col-12">
                    <h1 class="text-center">Manage Abandoned Baskets</h1>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12 d-flex justify-content-end">
                <a href="/api/rep/export_baskets" class="btn btn-primary">Export<i class="fa-regular fa-cloud-arrow-down"></i></a>
            </div>
        </div>

        <div class="row" v-if="baskets">
            <div class="col-12 mb-standard">
                <div class="quotes">
                    <div class="quote-item mb-3 bg-white d-flex flex-column flex-lg-row box-shadow rounded justify-content-around" v-for="basket in baskets" :key="basket.id">
                        <div class="d-flex justify-content-center col-12 col-lg-4">
                            <div class="d-flex align-items-center text-center">
                                <p class="mb-0 font-vag-bold"><b>
                                    {{ basket.customer.name }}
                                </b></p>
                            </div>
                        </div>



                        <div class="d-flex justify-content-center col-lg-2 col-12 align-items-center flex-lg-column text-center order-price-status">
                            <p class="mb-0 small d-lg-inline d-none"><b><span v-text="__('vue.manage-abandoned-orders.basket_value')"></span>:</b></p>
                            <p class="mb-0 font-vag-bold color-primary-green"><b>
                                <span v-html="basket.currency.symbol"></span>
                                {{ basket.grand_total | currencyDecimals }}
                            </b></p>
                        </div>

                        <div class="d-flex justify-content-center col-lg-2 col-12 align-items-center text-center flex-lg-column quote-date">
                            <p class="mb-0 small d-lg-inline d-none"><b><span v-text="__('vue.manage-abandoned-orders.updated')"></span>:</b></p>
                            <p class="mb-0 font-vag-bold"><b><span class="d-lg-none d-inline"><span v-text="__('vue.manage-abandoned-orders.updated')"></span>:</span> {{ basket.updated_at | formatDate }}</b></p>
                        </div>

                        <div class="d-flex justify-content-center col-lg-2 col-12 align-items-center text-center flex-lg-column quote-date">
                            <p class="mb-0 small d-lg-inline d-none"><b><span v-text="__('vue.manage-abandoned-orders.created')"></span>:</b></p>
                            <p class="mb-0 font-vag-bold"><b><span class="d-lg-none d-inline"><span v-text="__('vue.manage-abandoned-orders.created')"></span>:</span> {{ basket.created_at | formatDate }}</b></p>
                        </div>

                        <div class="align-items-center text-center justify-content-center d-flex col-12 col-lg-2">
                            <a class="btn btn-secondary no-text me-2" :href="'/rep/abandoned-baskets/' + basket.id" :title="__('vue.manage-abandoned-baskets.view')"><i class="fa-regular fa-eye"></i></a>
                        </div>
                    </div>
                </div>



                <div class="pagination">
                    <div class="pagination-content" v-if="baskets && total > perPage">
                        <div class="pagination-container">
                            <template v-for="link in links">
                                <div class="pagination-item"
                                     :key="link.label"
                                     v-if="!isNaN(link.label) || link.label === '...'"
                                     v-bind:class="link.label == currentPage ? 'active' : ''">
                                    <div>
                                        <p class="cursor-pointer" @click="getBaskets(link.label)">{{ link.label }}</p>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-5" v-if="baskets != null && baskets.length < 1 && !loading">
                <h3>No baskets found for this rep</h3>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'listData'
    ],
    data() {
        return {
            search: null,
            loading: false,
            cancelTokenSrc: null,
            baskets: null,
            reps: null,
            selectedRep: 0,
            orderBy: 0,
            orderByArray: ['id', 'desc'],
            currentPage: 1,
            total: 0,
            links: [],
            perPage: null,
            lastPage: null,
        };
    },
    mounted() {
        this.getBaskets();
    },

    methods: {
        getBaskets(page = 1) {
            this.loading = true;

            // Default params.
            let params = {
                'page': page,
            };

            // Merge in the search.
            if (this.search) {
                params = extend(params, {
                    'search': this.search,
                });
            }

            if (this.cancelTokenSrc) {
                this.cancelTokenSrc.cancel("Interrupted by the user.");
            }

            this.cancelTokenSrc = axios.CancelToken.source();

            axios.get("/api/rep/abandoned_baskets", {
                params: params,
                cancelToken: this.cancelTokenSrc.token,
            }).then(res => {
                this.setData(res.data);
            })
                .catch(err => {
                    // Response is undefined if request is cancelled.
                    if (err.response) {
                        this.loading = false;
                    }
                })
                .finally(x => {
                    this.cancelTokenSrc = null;
                    this.loading = false;
                });


        },
        setData(data) {
            this.baskets = data.data;

            // Meta.
            this.links = data.links;
            this.currentPage = data.current_page;
            this.total = data.total;
            this.perPage = data.per_page;
            this.lastPage = data.last_page;
            this.from = data.from ?? 0;
            this.to = data.to ?? 0;

            this.loading = false;


        },
    }
};
</script>
